import appContent from './content/appContent.typed';

const getIsAutoDeliveryDcxEnabled = (): boolean => {
    const content = appContent.getAutoDeliveryContent();

    return !!content;
};

export default {
    getIsAutoDeliveryDcxEnabled,
};
